var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("h4", { staticClass: "pb-2" }, [
      _vm._v(_vm._s(_vm.$t("message.booking.new_booking.subscription_title")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-items-stretch text-center" }, [
      _c(
        "div",
        {
          staticClass:
            "col-6 card card-body flex-items mr-1 pointer-item shadow-sm",
          class: { "panel-service-active": _vm.packageType === null },
          on: {
            click: function($event) {
              return _vm.setPackageType(null)
            }
          }
        },
        [
          _c("div", { staticClass: "text-primary" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("message.booking.new_booking.basic")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4" }, [
            _vm._v(_vm._s(_vm.$t("message.subscription.just_once")))
          ])
        ]
      ),
      _vm._v(" "),
      _vm.unlimitedPackageType
        ? _c(
            "div",
            {
              staticClass:
                "col-6 card card-body flex-items ml-1 pointer-item shadow-sm",
              class: { "panel-service-active": _vm.packageType },
              on: {
                click: function($event) {
                  return _vm.setPackageType(_vm.unlimitedPackageType)
                }
              }
            },
            [
              _c("div", { staticClass: "text-primary" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.booking.new_booking.package")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("message.booking.new_booking.multi_dates_booking")
                  )
                )
              ]),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "mt-4 text-pink mt-auto" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.booking.new_booking.max_discount", {
                        maxDiscount: _vm.maxDiscount
                      })
                    ) +
                    "\n      "
                )
              ])
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.packageType && _vm.packageType.category === "unlimited"
      ? _c("div", { staticClass: "card shadow-sm" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "text-orange" }, [
              _c("i", { staticClass: "fas fa-tag" }),
              _vm._v(
                " " + _vm._s(_vm.$t("message.package.promotions")) + "\n      "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2" }, [
              _c(
                "ul",
                { staticClass: "list-unstyled mb-0" },
                _vm._l(_vm.packageType.package_type_discounts, function(
                  packageTypeDiscount,
                  index
                ) {
                  return _c("li", [
                    _vm._v(
                      "\n            - " +
                        _vm._s(_vm._f("multiLangName")(packageTypeDiscount)) +
                        "\n          "
                    )
                  ])
                }),
                0
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6607de1b", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6607de1b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/newSteps/components/BookingPlan.vue
// module id = 1823
// module chunks = 0